import type { DeepString } from "@/lib/i18n";

export const pl = {
  defaultTitle: "Co mówią o nas klienci",
  prev: "Poprzednia",
  next: "Następna",
  goToSlide: "Przejdź do referencji",
} as const;

export type WClientTestimonialsCardsTranslations = DeepString<typeof pl>;
